module.exports = __webpack_public_path__ + "img/framenew_box25.7052a101.jpg";